import RestService from './RestService';

export default class Notes extends RestService {
    constructor(parentService, parentId) {
        super(`${parentService.baseUrl}/${parentId}/notes`);
    }
}
